module.exports = __webpack_public_path__ + "static/email_header-93fdde22e504a4d947ebfcf14500c25a.png";